import { useEffect } from 'react';
import { useAddRenderComponents } from './useAddRenderComponent';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export const RegisterRenderComponents = ({
  children,
  renderEmpty,
  renderColumnLoadedMarker,
  renderBoardQueryStartedMarker,
  renderBoardLoadedMarker,
  renderCardLoadedMarker
}) => {
  const addRenderComponents = useAddRenderComponents();
  useEffect(() => {
    addRenderComponents([{
      key: 'renderEmpty',
      renderComponent: renderEmpty
    }]);
    if (renderColumnLoadedMarker) {
      addRenderComponents([{
        key: 'renderColumnLoadedMarker',
        renderComponent: renderColumnLoadedMarker
      }]);
    }
    if (renderBoardQueryStartedMarker) {
      addRenderComponents([{
        key: 'renderBoardQueryStartedMarker',
        renderComponent: renderBoardQueryStartedMarker
      }]);
    }
    if (renderBoardLoadedMarker) {
      addRenderComponents([{
        key: 'renderBoardLoadedMarker',
        renderComponent: renderBoardLoadedMarker
      }]);
    }
    if (renderCardLoadedMarker) {
      addRenderComponents([{
        key: 'renderCardLoadedMarker',
        renderComponent: renderCardLoadedMarker
      }]);
    }
  }, [addRenderComponents, renderEmpty, renderColumnLoadedMarker, renderBoardQueryStartedMarker, renderBoardLoadedMarker, renderCardLoadedMarker]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: children
  });
};